import { EmergencyAlerts } from '@massds/mayflower-react';
import './index.scss';

export default EmergencyAlerts;
